import {
  useWSModal,
  WSCard,
  WSFlexBox,
  WSText
} from "@wingspanhq/fe-component-library";
import { formatMoney } from "@wingspanhq/utils/dist/formatMoney";
import { useHistory } from "react-router-dom";
import { useQueryInternalAccountBalance } from "../../../query/banking/queries/useQueryInternalAccountBalance";
import { useQueryInternalAccounts } from "../../../query/banking/queries/useQueryInternalAccounts";
import { selectorActiveBankingAccount } from "../../../shared/selectors/selectorActiveBankingAccount";
import { ModalAccountDetails } from "./ModalAccountDetails";
import { useModalBalanceInfo } from "../modals/useModalBalanceInfo";

export const AvailableBalance: React.FC = () => {
  const queryInternalAccounts = useQueryInternalAccounts();
  const internalAccount = queryInternalAccounts.data?.find(
    selectorActiveBankingAccount
  );
  const queryInternalAccountBalance = useQueryInternalAccountBalance(
    internalAccount?.internalAccountId!,
    {
      enabled: !!internalAccount?.internalAccountId
    }
  );

  const history = useHistory();
  const modalAccountDetails = useWSModal(ModalAccountDetails, {
    size: "S"
  });
  const modalBalanceInfo = useModalBalanceInfo();
  const availableBalance = queryInternalAccountBalance.data?.available || 0;
  const currentBalance = queryInternalAccountBalance.data?.balance || 0;
  const pendingAmounts = queryInternalAccountBalance.data?.hold || 0;

  return (
    <WSCard
      shimmer={
        queryInternalAccounts.isInitialLoading ||
        queryInternalAccountBalance.isInitialLoading
      }
      fullHeight
      header={{
        value: {
          action: internalAccount?.numbers?.account
            ? {
                label: `Account details (...${internalAccount.numbers.account.slice(
                  internalAccount.numbers.account.length - 4
                )})`,
                rightIcon: "chevron-right",
                onClick: () => modalAccountDetails.open()
              }
            : undefined
        },
        label: {
          text: "Available balance",
          link: {
            icon: "info-circle",
            onClick: () => modalBalanceInfo.open()
          }
        }
      }}
      divider
      actions={{
        alignment: "fill",
        sortButtons: false,
        buttons: [
          {
            label: "Transfer",
            kind: "Secondary",
            onAsyncClick: async () => {
              history.push("/member/transfer?balance=wallet");
            }
          }
          /*
          {
            label: "View transactions",
            kind: "Link",
            rightIcon: "chevron-right",
            onClick: () => {
              history.push("/member/wallet/transactions");
            }
          }
          */
        ]
      }}
    >
      <WSText.Heading1
        weight="book"
        color={availableBalance > 0 ? "gray600" : "gray200"}
        mb="XL"
      >
        {formatMoney(
          availableBalance,
          queryInternalAccountBalance.data?.currency || "USD"
        )}
      </WSText.Heading1>

      <WSFlexBox.CenterY justify="space-between" mb="M">
        <WSText.ParagraphSm color="gray500">Total balance</WSText.ParagraphSm>
        <WSText.ParagraphSm color="gray600">
          {formatMoney(
            currentBalance,
            queryInternalAccountBalance.data?.currency || "USD"
          )}
        </WSText.ParagraphSm>
      </WSFlexBox.CenterY>
      <WSFlexBox.CenterY justify="space-between">
        <WSText.ParagraphSm color="gray500">Pending amounts</WSText.ParagraphSm>
        <WSText.ParagraphSm color="gray500">
          {formatMoney(
            pendingAmounts,
            queryInternalAccountBalance.data?.currency || "USD"
          )}
        </WSText.ParagraphSm>
      </WSFlexBox.CenterY>
      <WSText.ParagraphXs color="gray500"> </WSText.ParagraphXs>
    </WSCard>
  );
};
